import { CandidateGoodsSearchConditionModel } from '../vo/candidate-goods-search-condition.model';
import { PlessViewUtilsSub } from '../../../kymw00/pless-view-utils-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

@Injectable()
export class MakeCandidateGoodsFileService extends PlessJsonResponderSub<any> {

  private vo: CandidateGoodsSearchConditionModel;

  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof MakeCandidateGoodsFileService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        Rec: {
          parameter: {
            ItemCode: this.vo.itemCode,
            EbaseSpecCode: this.vo.ebaseSpecCode,
            DataType: this.vo.dataType,
            JANCode: this.vo.janCode,
            MakerName: this.vo.makerName,
            OrdrClientCode: this.vo.ordrClientCode,
            OrdrClientKanji: this.vo.ordrClientKanji,
            PayeeClientCode: this.vo.payeeClientCode,
            PayeeClientKanji: this.vo.payeeClientKanji,
            ClassCode: this.vo.classCode,
            MiddleClassCode: this.vo.middleClassCode,
            SmallClassCode: this.vo.smallClassCode,
            RegistDateFrom: this.vo.registDateFrom,
            RegistDateTo: this.vo.registDateTo,
            UpdateDateFrom: this.vo.updateDateFrom,
            UpdateDateTo: this.vo.updateDateTo,
            AdmitStatus: this.vo.admitStatus,
            GoodsDiv: this.vo.goodsDiv,
            BuyerCode: this.vo.buyerCode
          },
          combination:  this.createCombinationPcode().concat(
            // 商品名
            this.vo.guideGoodsNameList.map(guideGoodsName => {
              return {
                parameter: {
                  GuideGoodsName: guideGoodsName
                }
              }
            })
          ).concat(
            // 規格名
            this.vo.guideStandardNameList.map(guideStandardName => {
              return {
                parameter: {
                  GuideStandardName: guideStandardName
                }
              }
            })
          ).concat(
            // 単協コード
            this.vo.coopCodeList.map(coopCode => {
              return {
                parameter: {
                  CoopCode: coopCode
                }
              }
            })
          ).concat(
            // 業態区分（デイリー）
            this.vo.dutiesFormDailyList.map(dutiesFormDaily => {
              return {
                parameter: {
                  DutiesFormDailyDiv: dutiesFormDaily
                }
              }
            })
          )
        }
      }
    });
  }

  private createCombinationPcode(): any[] {
    return PlessViewUtilsSub.isEmpty(this.vo.pcode) && !PlessViewUtilsSub.isEmptyArray(this.vo.pcodeList) ?
      // リスト検索
      this.vo.pcodeList.map(pCode => {
        return {
          parameter: {
            Pcode: pCode
          }
        };
      }) : !PlessViewUtilsSub.isEmpty(this.vo.pcode) ?
        // 通常検索
        [{
          parameter: {
            Pcode: this.vo.pcode
          }
        }] : [];
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof MakeCandidateGoodsFileService
   */
  execute(vo: CandidateGoodsSearchConditionModel, successFunc: Function = null): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('makeCandidateGoodsFile', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof MakeCandidateGoodsFileService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
